// extracted by mini-css-extract-plugin
export default {"contenedor-titulo":"estilos_contenedor-titulo__87rmB","titulo":"estilos_titulo__8bY53","pleca-horizontal":"estilos_pleca-horizontal__g-iE6"};